import { ROADSIDE_SERVICES_CODES } from 'entities/roadsideServices';

export const checkIsStation = (roadsideServiceCode: number) => (
  roadsideServiceCode === ROADSIDE_SERVICES_CODES.gasStation
);
